import { CustomerPricelistSortData, SortDirection, SortField } from '../app/data/model';

export {
  AddCustomerPricelistItemsCommand,
  BrowseCustomerPricelistItemsQuery,
  CreateCustomerPricelistCommand,
  DeleteCustomerPricelistsCommand,
  GetCustomerPricelistExcelQuery,
  GetCustomerPricelistMetadataQuery,
  GetCustomerPricelistQuery,
  GetCustomerPricelistsQuery,
  GetProductFacetsQuery,
  GetProductsByFamiliesQuery,
  GetProductFamilyDetailsQuery,
  GetProductModelAccessoriesQuery,
  GetProductDetailsQuery,
  GetProductModelDetailsQuery,
  GetProductModelsDetailsQuery,
  GetTermsAndConditionsQuery,
  RemoveCustomerPricelistItemsCommand,
  UpdateCustomerPricelistCommand,
} from '../app/data/model';

export const PRICELISTS_DEFAULT_SORT: CustomerPricelistSortData = {
  direction: SortDirection.Descending,
  sortField: SortField.ModifiedDate,
};
